export enum ParaTimeSelectorStep {
  /**
   * Graph interactions disabled - explore button shown on top of graph
   */
  EnableExplore,
  /**
   * Show help screen
   */
  ShowHelpScreen,
  /**
   * Graph interactions enabled
   */
  Explore,
}
